import React from 'react';
import Card from 'react-bootstrap/Card';
import './NewsCard.css';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NewsCard = ({ image, title, desc, learnMoreLink }) => {
  const { t } = useTranslation();

  function cutStringToWordCount(str, count) {
    if (typeof str !== 'string') return '';
    const words = str.trim().split(/\s+/);
    if (words.length <= count) return str;
    return words.slice(0, count).join(' ') + '...';
  }

  const renderLink = () => {
    if (!learnMoreLink) return null;

    const isInternal = learnMoreLink.startsWith('/');

    return isInternal ? (
      <Link to={learnMoreLink} className="news-card__link">
        {t('Learn More')} <BsArrowRight className="news-card__arrow" />
      </Link>
    ) : (
      <a href={learnMoreLink} className="news-card__link">
        {t('Learn More')} <BsArrowRight className="news-card__arrow" />
      </a>
    );
  };

  return (
    <Card className="news-card">
      <Card.Img className="news-card__img" variant="top" src={image} />
      <Card.Body className="news-card__body" as="div">
        <h3 className="news-card__title">{t(title)}</h3>
        <p className="news-card__desc">{cutStringToWordCount(t(desc), 32)}</p>
        {renderLink()}
      </Card.Body>
    </Card>
  );
};

export default NewsCard;
